import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import CommonErrorContent from '../CommonErrorContent/CommonErrorContent';

const LoginFailed: FunctionComponent = () => {
  const { t } = useTranslation('authentication');
  const history = useHistory();

  const handleClick = (): void => {
    history.push('/authentication/login');
  };

  return (
    <CommonErrorContent
      title={t('LoginFailedComponent.title')}
      subtitle={t('LoginFailedComponent.subtitle')}
      content={t('LoginFailedComponent.content')}
      buttonText={t('LoginFailedComponent.backButton')}
      onButtonClick={handleClick}
    />
  );
};

export default LoginFailed;
